<div class="d-flex flex-column">
  <div class="detail-label">{{ label }}</div>
  <div class="detail-value {{ submissionState }}" [class.changed]="hasChanged">{{ value }}</div>
</div>
